// covered-by: frontends/carrie/src/config/__tests__/askRouteTree.test.ts
import { askV2AuthLayoutRoute } from "./routes/authLayout";
import { askV2IndexRoute } from "./routes/indexRoute";

import { forgotPasswordRoute } from "../routes/forgot-password/route";
import { loginRoute } from "../routes/login/route";
import { logoutRoute } from "../routes/logout/route";
import { resetPasswordRoute } from "../routes/reset-password/route";
import { unauthLayoutRoute } from "../routes/unauth-layout/route";

/**
 * Top-level children of rootRoute when the Ask host gate is on.
 *
 * Login is reused (same WorkOS view) so `loginRoute.useSearch()` keeps working.
 * Tickets / V1 Ask Puntt / PunttLayout are intentionally omitted.
 */
export const askV2ChildRoutes = [
  unauthLayoutRoute.addChildren([
    loginRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
  ]),
  logoutRoute,
  askV2AuthLayoutRoute.addChildren([askV2IndexRoute]),
];
